type TiunEventContent =
  | 'TIUN_SNIPPET_INITIALIZED'
  | 'TIUN_HIDE_PAYWALL'
  | 'TIUN_SHOW_PAYWALL'
  | 'TIUN_UPDATE_CONTENT';

interface TiunEventData {
  type: 'TIUN_EVENT';
  content: TiunEventContent;
  sessionId?: string;
}

interface TiunAjaxResponse {
  html?: string;
  error?: string;
}

let initialized = false;

function isTiunEventData(value: unknown): value is TiunEventData {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const candidate = value as Record<string, unknown>;
  return candidate.type === 'TIUN_EVENT' && typeof candidate.content === 'string';
}

function scrollToHeadline(selector: string): void {
  const headline = document.querySelector<HTMLElement>(selector);
  if (!headline) {
    return;
  }

  headline.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}

async function loadHiddenPaywallContent(pageId: string, sessionId: string): Promise<void> {
  const requestBody = new URLSearchParams({
    'tx_tiun_ajax[action]': 'loadContent',
    'tx_tiun_ajax[controller]': 'Ajax',
    'tx_tiun_ajax[pageId]': pageId,
    'tx_tiun_ajax[sessionId]': sessionId,
  });

  const response = await fetch('/tiunapi?type=1739573010', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: requestBody.toString(),
  });

  const data = (await response.json()) as TiunAjaxResponse;
  if (!response.ok || typeof data.html !== 'string') {
    return;
  }

  const article = document.querySelector<HTMLElement>('main.content');
  if (article) {
    article.style.display = 'none';
    article.classList.add('tiun-hidden');
  }

  const hideContainer = document.getElementById('hide-paywall-container');
  if (!hideContainer) {
    return;
  }

  hideContainer.innerHTML = data.html;
  scrollToHeadline('#hide-paywall-container h1');
}

function showPaywallContent(): void {
  const hideContainer = document.getElementById('hide-paywall-container');
  if (hideContainer) {
    hideContainer.innerHTML = '';
  }

  const article = document.querySelector<HTMLElement>('main.content');
  if (!article) {
    return;
  }

  article.style.display = 'block';
  article.classList.add('tiun-show');
  scrollToHeadline('main');
}

function updateContentInfo(): void {
  const pageId = document.body.dataset.pageId ?? '';
  const paywallElement = document.getElementById('show-paywall-container');
  const isPaidContent = paywallElement ? 'active' : 'inactive';

  window.postMessage(
    {
      type: 'TIUN_EVENT',
      content: 'TIUN_UPDATE_CONTENT',
      contentId: pageId,
      contentType: isPaidContent,
    },
    window.location.origin
  );
}

window.addEventListener('message', (event: MessageEvent<unknown>) => {
  if (!isTiunEventData(event.data)) {
    return;
  }

  if (event.data.content === 'TIUN_SNIPPET_INITIALIZED') {
    initialized = true;
    updateContentInfo();
    return;
  }

  if (event.data.content === 'TIUN_HIDE_PAYWALL') {
    const paywallElement = document.getElementById('show-paywall-container');
    const isPaidContent = paywallElement ? 'active' : 'inactive';

    if (isPaidContent !== 'active') {
      return;
    }

    const sessionId = event.data.sessionId ?? '';
    const pageId = document.body.dataset.pageId ?? '';
    if (sessionId === '' || pageId === '') {
      return;
    }

    void loadHiddenPaywallContent(pageId, sessionId);
    return;
  }

  if (event.data.content === 'TIUN_SHOW_PAYWALL') {
    showPaywallContent();
  }
});
